import mobile from "is-mobile";

export const shouldPreloadCardImages = !mobile();